import { h } from 'preact';
import { useState } from 'preact/hooks';
import { ArticleSurvey } from 'core_main/api/knowledge_bases/types';
import Button from 'widget_main/components/Button/Button';
import { getKustomerCore } from 'widget_main/globals/helpers';
import styles from './kbArticleSurveyFeedback.scss';
import KBArticleSurveyFeedbackSuggestedReasons from './KBArticleSurveyFeedbackSuggestedReasons/KBArticleSurveyFeedbackSuggestedReasons';
import KBArticleSurveyFeedbackWrittenFeedback from './KBArticleSurveyFeedbackWrittenFeedback/KBArticleSurveyFeedbackWrittenFeedback';

const kustomerCore = getKustomerCore();

export interface KBArticleSurveyProps {
  articleId: string;
  feedbackId: string;
  articleSurveyConfig: ArticleSurvey;
  setSurveyResponse: (ArticleSurveyResponseData, error?) => void;
}
const KBArticleSurvey = ({
  articleId,
  feedbackId,
  articleSurveyConfig,
  setSurveyResponse,
}: KBArticleSurveyProps) => {
  const [writtenFeedbackText, setWrittenFeedbackText] =
    useState<Maybe<string>>(undefined);
  const [suggestedReasonsChecked, setSuggestedReasonsChecked] = useState({});
  if (
    !articleId ||
    (!articleSurveyConfig.suggestedReasonsEnabled &&
      !articleSurveyConfig.writtenFeedbackEnabled)
  )
    return null;
  const handleSubmit = () => {
    setSurveyResponse('SENT');
    kustomerCore.updateArticleFeedback(
      {
        articleId,
        feedbackId,
        suggestedReasons: Object.keys(suggestedReasonsChecked),
        writtenFeedback: writtenFeedbackText,
      },
      setSurveyResponse,
    );
  };
  const handleCheckSuggestedReason = (checked, value) => {
    const updatedReasons = { ...suggestedReasonsChecked };
    if (checked) {
      updatedReasons[value] = true;
    } else {
      delete updatedReasons[value];
    }
    setSuggestedReasonsChecked(updatedReasons);
  };
  const handleChangeWrittenFeedback = (e) => {
    setWrittenFeedbackText((e.target as HTMLTextAreaElement)?.value);
  };
  const isSubmitButtonDisabled = () => {
    const hasSuggestedReasons = Object.keys(suggestedReasonsChecked).length > 0;
    const hasWrittenFeedback =
      writtenFeedbackText && writtenFeedbackText?.length > 0;
    if (
      articleSurveyConfig.suggestedReasonsEnabled &&
      articleSurveyConfig.writtenFeedbackEnabled &&
      (hasSuggestedReasons || hasWrittenFeedback)
    )
      return false;
    if (articleSurveyConfig.writtenFeedbackEnabled && hasWrittenFeedback) {
      return false;
    }
    if (articleSurveyConfig.suggestedReasonsEnabled && hasSuggestedReasons) {
      return false;
    }
    return true;
  };

  return (
    <div>
      <KBArticleSurveyFeedbackSuggestedReasons
        enabled={articleSurveyConfig.suggestedReasonsEnabled}
        onClick={handleCheckSuggestedReason}
        suggestedReasonsChecked={suggestedReasonsChecked}
        title={articleSurveyConfig.suggestedReasonsTitle}
        suggestedReasons={articleSurveyConfig.suggestedReasons}
      />

      <KBArticleSurveyFeedbackWrittenFeedback
        enabled={articleSurveyConfig.writtenFeedbackEnabled}
        onChange={handleChangeWrittenFeedback}
        title={articleSurveyConfig.writtenFeedbackTitle}
      />
      <Button
        className={styles.articleSurveySubmitButton}
        ariaLabel={articleSurveyConfig.submitButtonText}
        onClick={handleSubmit}
        disabled={isSubmitButtonDisabled()}
        variant="primary"
      >
        {articleSurveyConfig.submitButtonText}
      </Button>
    </div>
  );
};

export default KBArticleSurvey;
